import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";
import logo from "../assets/logo.png";
import { API_BASE_URL } from "../config";

const SwapPaymentSuccess = () => {
  const { dealId } = useParams();
  const navigate = useNavigate();


  const [loading, setLoading] = useState(true);
  const [deal, setDeal] = useState(null);
  const [payment, setPayment] = useState(null);

  /* ============================================================
        LOAD PAYMENT + DEAL DETAILS
  ============================================================ */
  useEffect(() => {
    const loadPaymentData = async () => {
      if (!dealId) {
        setLoading(false);
        return;
      }

      try {
  const token = localStorage.getItem("token");

const res = await axios.get(
`${API_BASE_URL}/api/swap-deals/deal/${dealId}`,
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);


        if (!res.data?.deal) {
          setLoading(false);
          return;
        }

        setDeal(res.data.deal);
        setPayment(res.data.payment || null);
      } catch (err) {
        console.error("Payment success error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadPaymentData();
}, [dealId]);

  /* ============================================================
        EARLY RETURNS
  ============================================================ */
  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;
  if (!deal) return <p style={{ textAlign: "center" }}>Deal not found.</p>;

  /* ============================================================
        DERIVED STATE
  ============================================================ */
  const bothPaid = deal.paymentA === 1 && deal.paymentB === 1;

  /* ============================================================
        RENDER
  ============================================================ */
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f6f8",
        padding: "40px 20px",
      }}
    >
      <img
        src={logo}
        alt="Client Exchange Logo"
        style={{
          width: "170px",
          display: "block",
          margin: "0 auto 30px",
        }}
      />

      <div
        style={{
          maxWidth: "720px",
          margin: "0 auto",
          background: "#ffffff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        }}
      >
        {/* SUCCESS HEADER */}
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <FaCheckCircle
            style={{
              fontSize: "72px",
              color: "#2e7d32",
              marginBottom: "15px",
            }}
          />

          <h1 style={{ color: "#2e7d32", marginBottom: "10px" }}>
            Payment Successful
          </h1>

          <p style={{ fontSize: "1.05rem", color: "#555" }}>
            Your lawn mowing swap payment has been received.
          </p>
        </div>

        {/* TRANSACTION SUMMARY */}
        <div
          style={{
            background: "#f1f8f4",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "25px",
          }}
        >
          <h3 style={{ color: "#2e7d32", marginBottom: "12px" }}>
            Transaction Summary
          </h3>

          <p><strong>Swap Reference:</strong> {deal.swap_reference}</p>
          <p><strong>Deal ID:</strong> {deal.id}</p>
          <p>
         <strong>Amount:</strong>{" "}
{payment?.amount
  ? `$${Number(payment.amount).toFixed(2)} AUD`
  : "Swap fee paid successfully"}
          </p>

          {payment?.stripeSessionId && (
  <p>
    <strong>Stripe Transaction ID:</strong><br />
    <code>{payment.stripeSessionId}</code>
  </p>
)}

          {payment?.created_at && (
            <p>
              <strong>Date:</strong>{" "}
              {new Date(payment.created_at).toLocaleString()}
            </p>
          )}
        </div>

        {/* STATUS MESSAGE */}
        {bothPaid ? (
          <div
            style={{
              marginBottom: "25px",
              padding: "15px",
              background: "#e8f5e9",
              borderRadius: "10px",
              color: "#1b5e20",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            ✔ Both users have paid — the swap is now active and ready for handover.
          </div>
        ) : (
          <div
            style={{
              marginBottom: "25px",
              padding: "15px",
              background: "#fff8e1",
              borderRadius: "10px",
              color: "#946200",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            ⏳ Waiting for the other user to complete their payment.
          </div>
        )}

        {/* NEXT STEPS */}
        <div
          style={{
            background: "#f9fdfb",
            padding: "20px",
            borderRadius: "12px",
            marginBottom: "30px",
          }}
        >
          <h3 style={{ color: "#2e7d32", marginBottom: "10px" }}>
            What happens next?
          </h3>

          <ul style={{ color: "#555", lineHeight: "1.7", paddingLeft: "20px" }}>
            <li>Your payment has been securely received.</li>
            <li>The other party must complete their swap fee.</li>
            <li>Once both payments are complete, the swap moves to handover.</li>
            <li>You’ll be notified automatically when the swap progresses.</li>
          </ul>
        </div>

        {/* ACTION BUTTONS */}
        <div style={{ display: "flex", gap: "15px" }}>
          <button
            onClick={() => navigate(`/swap-deal/${deal.id}`)}
            style={{
              flex: 1,
              padding: "14px",
              background: "#2e7d32",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            View Swap Deal
          </button>

          <button
            onClick={() => navigate("/dashboard")}
            style={{
              flex: 1,
              padding: "14px",
              background: "#0288d1",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SwapPaymentSuccess;
